import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface HistoryArray{
  value: number;
}
interface EnvironmentArray{
  value: number;
}
interface MunicipalityArray{
  value: string;
}

interface CategoryState {
  History: HistoryArray[];
  Environment: EnvironmentArray[];
  Municipality: MunicipalityArray[];
}

const initialState: CategoryState = {
  History:  [],
  Environment: [],
  Municipality: []
};

export const CategorySlice = createSlice({
  name: 'Categories',
  initialState,
  reducers: {
    History: (state, action) => {
      // state.History.splice(0, state.History.length);
      // state.History.push(action.payload)
      state.History = [];
      action.payload == '' ? state.History = [] : state.History.push(action.payload)
    },
    Environment: (state, action) => {
      state.Environment = [];
      action.payload == '' ? state.Environment = [] : state.Environment.push(action.payload)
    },
    Municipality: (state, action) => {
      state.Municipality = [];
      action.payload == '' ? state.Municipality = [] : state.Municipality.push(action.payload)
    }
  },
})

export const { History, Environment, Municipality } = CategorySlice.actions
export default CategorySlice.reducer 